export const Keys = {
  RECAPTCHA_CLIENT_SITEKEY: '6LesImQUAAAAADQzqR_mBzWud3uB0ZB1opaNhkD0',
};
